import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar as faStarFull } from '@fortawesome/free-solid-svg-icons'
import { faStar as faStarEmpty } from '@fortawesome/free-regular-svg-icons'
import "../scss/v2/opinion.scss"

function Cookie(props) {

    const { t, i18n } = useTranslation();
    const [count, setCount] = useState(0);

    useEffect(() => {
        i18n.changeLanguage(props.lang);
    }, [i18n, props.lang]);

    i18n.on('loaded', function () {
        let dbCount = parseInt(t('opinion.count'));
        if (!Number.isInteger(dbCount)) dbCount = 0;
        setCount(dbCount);
    });

    function renderStarts(index) {
        let starCount = parseInt(t('opinion.box.' + index + '.star'));
        if (!Number.isInteger(starCount)) starCount = 5;

        const starts = [];

        for (let i = 1; i <= 5; i++) {
            if (i <= starCount) starts.push(<FontAwesomeIcon icon={faStarFull} key={i} />)
            else starts.push(<FontAwesomeIcon icon={faStarEmpty} key={i} />)
        }

        return starts;
    }

    function renderOpinions() {

        const opinions = [];

        for (let i = 1; i <= count; i++) {
            opinions.push(
                <div className="col-12 col-lg-4" key={i} >
                    <div className="opinion-box" >
                        <div className="opinion-box-star" >{renderStarts(i)}</div>
                        <div className="opinion-box-date" >{t('opinion.box.' + i + '.date')}</div>
                        <div className="opinion-box-message my-3" >{t('opinion.box.' + i + '.message')}</div>
                        <div className="opinion-box-from" >{t('opinion.box.' + i + '.from')}</div>
                    </div>
                </div>
            )
        }

        return opinions;
    }

    return (
        <div className="opinion container">
            <Helmet>
                <title>{t("meta.title.opinion")}</title>
                <meta name="description" content={t("meta.description.opinion")} />
            </Helmet>
            <h1 className="opinion-title">{t('opinion.title')}</h1>
            <div className="opinion-text mb-5" dangerouslySetInnerHTML={{ __html: t('opinion.text') }} />
            <div className="row" >{renderOpinions()}</div>
        </div>
    )

}

export default Cookie